import type { TicketMessage } from '../../types';
import styles from './MessageThread.module.css';

interface MessageThreadProps {
	messages: TicketMessage[];
}

export const MessageThread = ({ messages }: MessageThreadProps) => (
	<div className={styles.thread}>
		{messages.map((msg) => (
			<div
				key={msg._id}
				className={`${styles.row} ${msg.fromMe ? styles.rowQuestion : styles.rowReply}`}
			>
				<p className={styles.text}>{msg.content}</p>
			</div>
		))}
	</div>
);
